import src from "IMAGE";
export default { src, width: 208, height: 55, blurWidth: 0, blurHeight: 0};
